import { Helmet } from "react-helmet-async";
import { openPopup } from "../../../store/popupSlice"
import { useDispatch } from "react-redux";
import Breadcrumb from "../../../component/Breadcrumb";
import { Link } from "react-router-dom";

const breadcrumbData = {
  newClass:"white-breadcrumb",
  list:[
    {
      page:"Home",
      slug:"/"
    },
    {
      page:"lyft clone app",
      slug:""
    },
  ]
}

export default function LyftBanner() {
  const dispatch = useDispatch();
  return (
    <>
    <Helmet>
      <link rel="preload" href="/assets/home/lyft-banner.webp" as="image" type="image/webp"/>
      <link rel="preload" href="/assets/home/lyft-banner-back.webp" as="image" type="image/webp"/>
    </Helmet>
      <section className="lyftclone-banner header-gap">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-6">
              <div className="lyftclone-banner-head">
                <Breadcrumb breadcrumbData={breadcrumbData}/>
                <label>Best ui & ux</label>
                <h1 className="heading">Lyft Clone App</h1>
                <p>Empower users to book, ride, and return vehicles with ease using our feature-rich Lyft Clone solution. Crafted for intuitive navigation and real-time trip tracking, our app ensures a smooth user experience from start to finish. Whether you're entering the ride-sharing market or scaling your existing business, this app gives you the competitive edge needed to thrive in the smart mobility space.</p>
                <button onClick={() => dispatch(openPopup())} className="default-btn">get free demo</button>

                <Link style={{ marginLeft: "15px" }} to={`/features/taxi-dispatch-software`} className="default-btn "> Explore Features </Link>
              </div>
            </div>

            <div className="col-lg-6 col-md-6">
              <div className="lyftclone-banner-image">
                <img src="/assets/home/lyft-banner.webp" alt="Lyft Clone" className="img-responsive" />
                <div className="lyft-banner-animate-box"></div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
